module.exports = root

var flow = require('../util/container-flow')

function root(node, _, context) {
  return flow(node, context)
}
